export default {"src":"/_next/static/media/PayPal.fa023c97.svg","height":33,"width":124};